// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueCookie from 'vue-cookie'
import App from './App'
import router from './router'
import SideMenu from './components/SideMenu.vue'
import localDb from './components/localDb'
import * as OfflinePluginRuntime from 'offline-plugin/runtime'
import VueI18n from 'vue-i18n'
import messages from './locale/pt_br'

Vue.use(VueCookie)
Vue.use(VueI18n)

Vue.config.productionTip = false

console.log("ENV=" + process.env.FSM_ENV)
console.log("FLAVOR=" + process.env.FSM_FLAVOR)
console.log("DEMO=" + process.env.FSM_DEMO)

const i18n = new VueI18n({
  locale: process.env.FSM_FLAVOR,
  fallbackLocale: 'outsourcing',
  messages
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>',
  data: {
    currentUser: localStorage.getItem('currentUser'),
    currentName: localStorage.getItem('currentName')
  }
})

localDb.open().catch(function(e) {
  console.error(e.stack)
})

OfflinePluginRuntime.install({
  onUpdating: () => {
    console.log('SW Event:', 'onUpdating');
  },
  onUpdateReady: () => {
    console.log('SW Event:', 'onUpdateReady');
    // Tells to new SW to take control immediately
    OfflinePluginRuntime.applyUpdate();
  },
  onUpdated: () => {
    console.log('SW Event:', 'onUpdated');
    // Reload the webpage to load into the new version
    window.location.reload();
  },
  onUpdateFailed: () => {
    console.log('SW Event:', 'onUpdateFailed');
  }  
});


// WEBPACK FOOTER //
// ./src/main.js